import {LabelStore} from '../base/label-store';
import {computed, makeObservable} from 'mobx';

import privacyPolicyTextEt from './privacy-text-et.md';
import privacyPolicyTextEn from './privacy-text-en.md';
import privacyPolicyTextFi from './privacy-text-fi.md';
import privacyPolicyTextLt from './privacy-text-lt.md';
import privacyPolicyTextLv from './privacy-text-lv.md';
import privacyPolicyTextRu from './privacy-text-ru.md';
import privacyPolicyTextSv from './privacy-text-sv.md';
import privacyPolicyTextPl from './privacy-text-pl.md';
import privacyPolicyTextJa from './privacy-text-ja.md';
import privacyPolicyTextVi from './privacy-text-vi.md';

export class PrivacyPolicyViewStore {

    constructor(private labelStore: LabelStore) {
        makeObservable(this);
    }

    @computed
    get privacyPolicyText(): string {
        switch (this.labelStore.language) {
            case 'en':
                return privacyPolicyTextEn;
            case 'et':
                return privacyPolicyTextEt;
            case 'fi':
                return privacyPolicyTextFi;
            case 'lt':
                return privacyPolicyTextLt;
            case 'lv':
                return privacyPolicyTextLv;
            case 'ru':
                return privacyPolicyTextRu;
            case 'sv':
                return privacyPolicyTextSv;
            case 'pl':
                return privacyPolicyTextPl;
            case 'ja':
                return privacyPolicyTextJa;
            case 'vi':
                return privacyPolicyTextVi;
        }
    }
}
